import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import GroupFilter from 'components/search_sidebar/group_filter';

import { addGroupFilterId, removeGroupFilterId, setGroupFilterIds } from "../store/actions/query";
import { delayRetrieveRecords } from "../store/actions/search";

export class PropertyGroupFilter extends React.Component {
  static propTypes = {
    addGroupFilterId: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    groupByDatabase: PropTypes.bool,
    groups: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      databaseId: PropTypes.number.isRequired,
      databaseName: PropTypes.string.isRequired
    })).isRequired,
    removeGroupFilterId: PropTypes.func.isRequired,
    selectedGroupIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    setGroupFilterIds: PropTypes.func.isRequired,
  };

  handleGroupSelect = (group) => {
    if (group.id === 'ungrouped') {
      this.props.setGroupFilterIds([group.id]);
    } else if (group.id) {
      this.props.addGroupFilterId(group.id);
    } else {
      this.props.setGroupFilterIds([]);
    }

    this.props.delayRetrieveRecords();
  };

  handleGroupDeselect = (group) => {
    if (group.id) {
      this.props.removeGroupFilterId(group.id);
    }

    this.props.delayRetrieveRecords();
  };

  render() {
    const { delayRetrieveRecords, setGroupFilterIds, ...props } = this.props;
    return (
      <GroupFilter
        {...props}
        allMembersGroupLabel="All Properties"
        onGroupDeselect={this.handleGroupDeselect}
        onGroupSelect={this.handleGroupSelect}
      />
    );
  }
}

const mapStateToProps = state => ({
  groupByDatabase: state.static.aggregateView,
  groups: state.properties.groups,
  selectedGroupIds: state.query.researchGroupIds,
  totalCount: state.search.meta.databasePropertyCount,
  totalUngroupedCount: state.search.meta.totalUngroupedCount
});

const mapDispatchToProps = {
  addGroupFilterId,
  delayRetrieveRecords,
  removeGroupFilterId,
  setGroupFilterIds
};

export default connect(mapStateToProps, mapDispatchToProps)(PropertyGroupFilter);
